export default "__VITE_ASSET__DeDigtW$__"